module.exports = __webpack_public_path__ + "static/meta/sqs/2024/layout_metadata.3c45e9b.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2024/meta/layout_metadata.tsv
// module id = f7q8
// module chunks = 0